export class DisplayLedger {
    public static RegisteredControls: { [key: string]: any } = {};
}
